export default {
  BRAND_GOLD: '#AB8F32BF',
  BRAND_BLACK: '#000000',
  BRAND_GRAY: '#808080',
  BRAND_LIGHT_GOLD: '#F5EDD5',
  LIGHT_GRAY: '#F5F5F5',
  ERROR: '#FA0000',
  BLUE: '#0202F7',
};
